import {inject, Injectable} from './di';
import {ConfigService} from './config/config-service';
import {Logger} from './logger';

@Injectable()
export class ImagePuncherService {
  private readonly configService = inject(ConfigService);
  private readonly logger = inject(Logger);

  constructor() {
    window.image_puncher = this.punch.bind(this);
  }

  /**
   *
   * @param imageUrl Image URL, or just a color
   * @param coords
   * @param isBlob
   */
  public async punch(
    imageUrl: string,
    coords: {width: number; height: number; left: number; top: number} | DOMRect,
    isBlob?: boolean,
  ): Promise<{
    default_background: string;
    background: string;
  }> {
    // TODO: get isBlob auto or from config or use blob shim
    // TODO documentation for this function

    const canvas = document.createElement('canvas');
    let coef = 1;
    const config = this.configService.config;
    if (config.tv?.hacks?.image_coef) {
      coef = 1.5;
    }
    canvas.width = 1280 * coef;
    canvas.height = 720 * coef;

    const ctx = canvas.getContext('2d')!;

    if (['#', 'rgb', 'hls'].some((p) => imageUrl.startsWith(p))) {
      // if imageUrl is actually a color
      this.drawColor(canvas, ctx, imageUrl);
    } else {
      const result = await this.drawImage(canvas, ctx, imageUrl);
      if (!result) {
        return Promise.reject();
      }
    }

    // TODO: return url or color for full
    if (isBlob) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject();
              return;
            }
            const defaultBackground = URL.createObjectURL(blob);

            ctx.clearRect(coords.left * coef, coords.top * coef, coords.width * coef, coords.height * coef);

            canvas.toBlob((blob2) => {
              if (!blob2) {
                reject();
                return;
              }
              const background = URL.createObjectURL(blob2);
              resolve({
                default_background: defaultBackground,
                background: background,
              });
            }, 'image/png');
          },
          'image/jpeg',
          0.8,
        );
      });
    } else {
      const defaultBackground = canvas.toDataURL('image/jpeg', 0.8);
      ctx.clearRect(coords.left * coef, coords.top * coef, coords.width * coef, coords.height * coef);
      const background = canvas.toDataURL('image/png');
      return {
        default_background: defaultBackground,
        background: background,
      };
    }
  }

  private drawColor(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, color: string) {
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  private drawImage(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, imageUrl: string) {
    return new Promise<boolean>((resolve) => {
      const img = new Image();
      img.onload = () => {
        //TODO: check image dimensions

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(true);
      };
      img.onerror = (err) => {
        this.logger.warn(`[ImagePuncherService] Unable to load image by URL: "${imageUrl}"`, err);
        resolve(false);
      };
      img.src = imageUrl;
    });
  }
}

declare global {
  interface Window {
    /**
     * @deprecated use ImagePuncherService instead
     */
    image_puncher: ImagePuncherService['punch'];
  }

  /**
   * @deprecated use ImagePuncherService instead
   */
  const image_puncher: ImagePuncherService['punch'];
}
